import { post } from './base'

export function motorcycleStudentList (params) {
  return post('bemotorcycleLearning/list', params)
}

export function motorcycleSummary () {
  return post('bemotorcycleLearning/summary', {})
}

export function motorcycleDetail (params) {
  return post('bemotorcycleLearning/detail', params)
}

export function createMotorcycleLearningRecord (params) {
  return post('bemotorcycleLearning/create', params)
}

export function reportMotorcycleRecord (recordId) {
  return post('bemotorcycleLearning/report', { recordId })
}

export function updateMotorcyclePendingRecord (params) {
  return post('bemotorcycleLearning/updatePending', params)
}

export function updateMotorcycleReportedTime (params) {
  return post('bemotorcycleLearning/updateReportedTime', params)
}
